import React, { useState, useMemo, Suspense } from 'react';
import './Photos.css';

// Lazy load the EnlargedImage component
const EnlargedImage = React.lazy(() => import('./EnlargedImage'));

// ✅ Memoized PhotoItem component to prevent unnecessary re-renders
const PhotoItem = React.memo(({ src, alt, onClick }) => {
  return (
    <div className="photo-item">
      <img
        src={src}
        alt={alt}
        className="photo-img"
        loading="lazy"
        onClick={onClick}
      />
    </div>
  );
});

function AnnualPage() {
  const total = 17;
  const [viewAll, setViewAll] = useState(false);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const visibleCount = viewAll ? total : 6;

  const handleImageClick = (image) => setEnlargedImage(image);
  const handleClose = () => setEnlargedImage(null);

  // ✅ Basic image loader
  const loadImage = (index) => `/images/annual/${index + 1}.jpg`;

  // ✅ useMemo to avoid recalculating the list
  const visibleImages = useMemo(() => {
    return Array.from({ length: visibleCount }, (_, index) => ({
      src: loadImage(index),
      alt: `Annual ${index + 1}`,
    }));
  }, [visibleCount]);

  return (
    <div className="photos-container">
      <h2 className="photos-heading">ANNUAL DAY CELEBRATION</h2>

      {enlargedImage && (
        <Suspense fallback={<div className="loading-overlay">Loading...</div>}>
          <EnlargedImage image={enlargedImage} onClose={handleClose} />
        </Suspense>
      )}

      <div className="photos-grid">
        {visibleImages.map((image, index) => (
          <PhotoItem
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => handleImageClick(image.src)}
          />
        ))}
      </div>

      {!viewAll && total > 6 && (
        <div className="view-all-btn-wrapper">
          <button className="view-all-btn" onClick={() => setViewAll(true)}>
            View All
          </button>
        </div>
      )}
    </div>
  );
}

export default AnnualPage;
